import {FC} from 'react'
import {CleanerEarning} from '../../services/api'

export const ACCENT = '#039540'
export const INK = '#1b1b29'
export const MUTED = '#7e8299'

export const fmt = (iso: string): string => {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString(undefined, {dateStyle: 'medium', timeStyle: 'short'})
}
export const fmtDate = (iso: string): string => {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(undefined, {dateStyle: 'medium'})
}
export const money = (n: string | number): string => `$${parseFloat(String(n || '0')).toFixed(2)}`

export const Section: FC<{title: string; subtitle?: string; children: React.ReactNode}> = ({title, subtitle, children}) => (
  <div style={{background: '#fff', borderRadius: 16, boxShadow: '0 6px 18px rgba(27,27,41,0.06)', overflow: 'hidden', marginBottom: 22}}>
    <div style={{padding: '18px 22px', borderBottom: '1px solid #f1f3f7'}}>
      <h2 style={{fontSize: 16, fontWeight: 800, color: INK, margin: 0}}>{title}</h2>
      {subtitle && <p style={{fontSize: 13, color: MUTED, margin: '4px 0 0'}}>{subtitle}</p>}
    </div>
    {children}
  </div>
)

export const Empty: FC<{children: React.ReactNode}> = ({children}) => (
  <div style={{padding: 32, textAlign: 'center', color: MUTED}}>{children}</div>
)

export const btnStyle = (bg: string, color: string, busy: boolean): React.CSSProperties => ({
  fontWeight: 700, fontSize: 14, color, background: bg, border: 'none', borderRadius: 10,
  padding: '10px 18px', cursor: busy ? 'not-allowed' : 'pointer', opacity: busy ? 0.7 : 1,
  minWidth: 84, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
})

const EARNING_BADGE: Record<CleanerEarning['status'], {label: string; bg: string; color: string}> = {
  OWED: {label: 'On your tab', bg: 'rgba(3,149,64,0.12)', color: '#1f9d5b'},
  PENDING_APPROVAL: {label: 'Awaiting approval', bg: 'rgba(255,168,0,0.15)', color: '#b8770a'},
  PAID: {label: 'Paid', bg: '#eef1f6', color: MUTED},
  DECLINED: {label: 'Declined', bg: '#fef2f2', color: '#dc2626'},
}
export const EarningBadge: FC<{status: CleanerEarning['status']}> = ({status}) => {
  const b = EARNING_BADGE[status]
  return <span style={{display: 'inline-block', marginTop: 3, fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', borderRadius: 999, padding: '2px 8px', background: b.bg, color: b.color}}>{b.label}</span>
}
